import { render, staticRenderFns } from "./EmployeeFolders.vue?vue&type=template&id=e12f2e0e&"
import script from "./EmployeeFolders.vue?vue&type=script&lang=js&"
export * from "./EmployeeFolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports